import Swiper, {Navigation, Autoplay} from 'swiper';

Swiper.use([Navigation, Autoplay])

export default class Usps {
    constructor() {
        this.slider()
    }

    slider() {
        if (document.querySelector('#usps')) {
            const slider = new Swiper('#usps .swiper-container', {
                sliderPerView: 1,
                spaceBetween: 50,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 6,
                        spaceBetween: 30
                    },

                },
            });
        }
    }
}
